import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Types from './Types';
import ClientProvider from './client';
export default createDemo(import.meta.url, Types, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/typography/demos/types/Types.tsx",
    "fileName": "Types.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\n\nexport default function Types() {\n  return (\n    <Box sx={{ width: '100%', maxWidth: 500 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Typography variant=\"h1\" gutterBottom>\n        h1. Heading\n      </Typography>\n      <Typography variant=\"h2\" gutterBottom>\n        h2. Heading\n      </Typography>\n      <Typography variant=\"h3\" gutterBottom>\n        h3. Heading\n      </Typography>\n      <Typography variant=\"h4\" gutterBottom>\n        h4. Heading\n      </Typography>\n      <Typography variant=\"h5\" gutterBottom>\n        h5. Heading\n      </Typography>\n      <Typography variant=\"h6\" gutterBottom>\n        h6. Heading\n      </Typography>\n      <Typography variant=\"subtitle1\" gutterBottom>\n        subtitle1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur\n      </Typography>\n      <Typography variant=\"subtitle2\" gutterBottom>\n        subtitle2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur\n      </Typography>\n      <Typography variant=\"body1\" gutterBottom>\n        body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,\n        neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum\n        quasi quidem quibusdam.\n      </Typography>\n      <Typography variant=\"body2\" gutterBottom>\n        body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,\n        neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum\n        quasi quidem quibusdam.\n      </Typography>\n      <Typography variant=\"button\" gutterBottom sx={{ display: 'block' }}>\n        button text\n      </Typography>\n      <Typography variant=\"caption\" gutterBottom sx={{ display: 'block' }}>\n        caption text\n      </Typography>\n      <Typography variant=\"overline\" gutterBottom sx={{ display: 'block' }}>\n        overline text\n      </Typography>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 56,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Typography from '@mui/material/Typography';\n\nexport default function Types() {\n  return (\n    <Box sx={{ width: '100%', maxWidth: 500 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Typography variant=\"h1\" gutterBottom>\n        h1. Heading\n      </Typography>\n      <Typography variant=\"h2\" gutterBottom>\n        h2. Heading\n      </Typography>\n      <Typography variant=\"h3\" gutterBottom>\n        h3. Heading\n      </Typography>\n      <Typography variant=\"h4\" gutterBottom>\n        h4. Heading\n      </Typography>\n      <Typography variant=\"h5\" gutterBottom>\n        h5. Heading\n      </Typography>\n      <Typography variant=\"h6\" gutterBottom>\n        h6. Heading\n      </Typography>\n      <Typography variant=\"subtitle1\" gutterBottom>\n        subtitle1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur\n      </Typography>\n      <Typography variant=\"subtitle2\" gutterBottom>\n        subtitle2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur\n      </Typography>\n      <Typography variant=\"body1\" gutterBottom>\n        body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,\n        neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum\n        quasi quidem quibusdam.\n      </Typography>\n      <Typography variant=\"body2\" gutterBottom>\n        body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos\n        blanditiis tenetur unde suscipit, quam beatae rerum inventore consectetur,\n        neque doloribus, cupiditate numquam dignissimos laborum fugiat deleniti? Eum\n        quasi quidem quibusdam.\n      </Typography>\n      <Typography variant=\"button\" gutterBottom sx={{ display: 'block' }}>\n        button text\n      </Typography>\n      <Typography variant=\"caption\" gutterBottom sx={{ display: 'block' }}>\n        caption text\n      </Typography>\n      <Typography variant=\"overline\" gutterBottom sx={{ display: 'block' }}>\n        overline text\n      </Typography>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 56,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
